import {
    AlertEventObject,
    EventSettingsObject,
    EventsStoredObjects,
    EventStoredObject,
    MonitorProcessingEvent,
    OddsObject,
} from "../../@types/response";
import {OrderConstants} from "../../constants/MonitorConstants";
import {isVisible} from "./events";
import {getOutcomesName} from "../../constants/CommonConstants";

/**
 * Get Default Market for Sport
 *
 * @param sportId
 */
const getDefaultForSport = (sportId: number) => {
    switch (sportId) {
        case 1:
            return "1"
        case 2:
            return "3"
        case 5:
            return "4"
        default:
            return null
    }
}

/**
 * Sort Events
 *
 * @param a
 * @param b
 * @param events
 * @param settings
 */
export const sortEvent = (a: AlertEventObject, b: AlertEventObject, events: EventsStoredObjects, settings: EventSettingsObject): number => {
    switch (settings.order) {
        case OrderConstants.DATE:
            if (events[a.id].date !== events[b.id].date) {
                return events[a.id].date - events[b.id].date
            } else
                return 0
        case OrderConstants.NONE:
        default:
            return 0
    }
}

/**
 * eventsListener
 *
 * @returns AlertMonitorObject
 * @param event
 * @param settings
 */
export function processEvent(event: MonitorProcessingEvent, settings: EventSettingsObject): AlertEventObject[] {
    let alerts: any = [];
    try {

        if (!('bookmakers' in event) || !settings || !isVisible(event, settings.sports)) {
            return []
        }

        const expire = new Date()
        expire.setHours(0)
        expire.setMinutes(0)
        expire.setSeconds(0)
        expire.setDate(expire.getDate() + settings.date)

        const startdt = new Date(event.date)
        if ((startdt < new Date()) || (settings.date > 0 && startdt >= expire)) {
            return []
        }

        let alert = processFilter(event._id, event, settings)

        if (!alert)
            return alerts
        alerts.push(alert)

    } catch (error) {
        console.error('Error on process event', error, event)
    }
    return alerts
}


function processFilter(eventId: number, event: MonitorProcessingEvent, settings: EventSettingsObject): null | AlertEventObject {
    if (!settings.bookmaker) return null;

    const bkKey = settings.bookmaker.toString();

    if (!event.bookmakers) return null;
    const bookmaker = event.bookmakers[bkKey];
    if (!bookmaker || !bookmaker.markets) return null;

    const from = settings.from;
    const to = settings.to === 1 ? Infinity : settings.to;

    for (const [marketId, market] of Object.entries(bookmaker.markets)) {
        if (!market || !market.sign) continue

        for (const [signId, sign] of Object.entries(market.sign)) {
            if (!sign) continue

            const isDefault = getDefaultForSport(event.sportId) != null
            if (!isDefault) continue

            const odd = sign.backOdd
            if (!(odd >= from && odd <= to)) continue

            return {
                id: eventId,
                marketId: marketId,
                signId: signId,
                bookmakerId: parseInt(bookmaker.id),
                odds: getOdds(bookmaker, marketId.toString()),
            }
        }
    }
    return null
}

function getOdds(bookmaker: any, marketId: string): OddsObject[] {
    const marketOdds = Object.assign({}, bookmaker.markets)[`${marketId}`] || {}
    const odds = Object.assign({}, marketOdds.sign ?? {})

    return Object
        .keys(odds)
        .map((signId) => {
            return {
                signId: parseInt(signId),
                sign: getOutcomesName(marketId, signId),
                odd: Math.round(odds[signId]?.backOdd * 100) / 100 || 0,
                firstBackOdd: odds[signId]?.firstBackOdd || 0
            }
        })
}

export function keySearch(query: string, event: EventStoredObject) {
    return query === ''
        || event.name.toLowerCase().includes(query)
        || event.category.toLowerCase().includes(query)
        || event.competition.toLowerCase().includes(query)
}